(function () {
  var BODY_CLASS = 'print-article-hero-only';
  var VIEWPORT_ATTR = 'data-print-article-hero-viewport';
  var PRINT_PT = '--print-article-hero-pt';
  var PRINT_PB = '--print-article-hero-pb';

  function clearPrintPaddingVars() {
    document.documentElement.style.removeProperty(PRINT_PT);
    document.documentElement.style.removeProperty(PRINT_PB);
  }

  function onAfterPrint() {
    document.body.classList.remove(BODY_CLASS);
    document.body.removeAttribute(VIEWPORT_ATTR);
    clearPrintPaddingVars();
    window.removeEventListener('afterprint', onAfterPrint);
  }

  function onTriggerClick(e) {
    e.preventDefault();
    var w = window.innerWidth;
    var mode;
    if (w <= 767) mode = 'narrow';
    else if (w <= 990) mode = 'tablet';
    else if (w <= 1279) mode = 'medium';
    else mode = 'wide';

    document.body.setAttribute(VIEWPORT_ATTR, mode);

    var hero = document.querySelector('.article-hero[data-print-pad-top]');
    if (hero) {
      var mobile = w <= 749;
      var pt = mobile
        ? hero.getAttribute('data-print-pad-top-mobile')
        : hero.getAttribute('data-print-pad-top');
      var pb = mobile
        ? hero.getAttribute('data-print-pad-bottom-mobile')
        : hero.getAttribute('data-print-pad-bottom');
      if (pt != null && pt !== '') document.documentElement.style.setProperty(PRINT_PT, pt + 'px');
      if (pb != null && pb !== '') document.documentElement.style.setProperty(PRINT_PB, pb + 'px');
    }

    document.body.classList.add(BODY_CLASS);
    window.addEventListener('afterprint', onAfterPrint);
    window.print();
  }

  function initCommentDrawer() {
    var drawer = document.querySelector('.hb-comment_drawer--main[js-comment-drawer]');
    if (!drawer) return;

    document.querySelectorAll('[js-comment-drawer]').forEach(function (el) {
      if (el.classList.contains('hb-comment_drawer--main')) return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        drawer.classList.add('is-open');
        document.body.classList.add("overflow-hidden")
      });
    });
    drawer.querySelectorAll('[js-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        drawer.classList.remove('is-open');
        document.body.classList.remove("overflow-hidden")
      });
    });
  }

  function init() {
    var triggers = document.querySelectorAll('[js-print-trigger], .js-print-trigger');
    triggers.forEach(function (el) {
      el.addEventListener('click', onTriggerClick);
    });
    initCommentDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
